import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { media: { type: String, default: "all" } }

  connect() {
    if (this.element.media !== this.mediaValue) {
      this.element.media = this.mediaValue
    }
  }
}
